import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-switcher',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './switcher.component.html',
  styleUrl: './switcher.component.scss'
})
export class SwitcherComponent {

  changeMode(e:any) {
    e.preventDefault();
    
    const htmlTag = document.documentElement;
    if (htmlTag.className.includes("dark")) {
      htmlTag.className = 'light'
    } else {
      htmlTag.className = 'dark'
    }
  }

  
  
  isLtr = true; // Variable to toggle mode

  toggleMode(event: Event) {
    event.preventDefault();
    const htmlTag = document.getElementsByTagName('html')[0];

    this.isLtr = !this.isLtr;

    if (this.isLtr) {
      htmlTag.dir = 'ltr';
    } else {
      htmlTag.dir = 'rtl';
    }
  }
}
